import React, { useState, useEffect, useContext } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormLabel,
  CFormInput,
  CRow,
  CCol,
  CFormSelect,
  CButton,
} from '@coreui/react'
import PropTypes from 'prop-types'
import { UserContext } from 'src/context/UserContext'
import { MuddaAPI } from './MuddaAPI'
import { CircularProgress } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { CONSTANTS } from 'src/constants'
import { convert_to_preeti } from 'src/helpers/PreetiConverter'

const initialState = {
  name: '',
  province: 1,
  status: 1,
  slug: null,
}

const MuddaForm = ({
  open,
  editMode,
  handleClose,
  editData,
  reload,
  setReload,
  fetching,
  selectedId,
}) => {
  // Response State
  const [response, setResponse] = useState({
    success: null,
    error: null,
  })
  // Mudda data
  const [muddaData, setMuddaData] = useState(initialState)

  // Lifecycle method to
  useEffect(() => {
    // console.log(editData)
    if (editData) {
      setMuddaData({
        name: editData.name,
        province: editData.province,
        slug: editData.slug,
        status: editData.status,
      })
    }
  }, [editData])

  useEffect(() => {
    if (open === false) {
      setResponse({
        success: null,
        error: null,
      })
    }
  }, [open])
  // User Context
  const [user] = useContext(UserContext)

  const [loading, setLoading] = useState(false)

  // function to handle mudda data changes
  const handleMuddaDataChange = (e) => {
    setMuddaData({ ...muddaData, [e.target.name]: convert_to_preeti(e.target.value) })
  }

  // Function to create Mudda
  const handleSubmit = (e) => {
    e.preventDefault()
    if (muddaData.name === '' || muddaData.name === null) {
      return
    }

    setLoading(true)

    {
      editMode
        ? MuddaAPI.editMudda(user.access_token, muddaData, selectedId)
            .then((res) => {
              if (res.data.status === true) {
                setMuddaData(initialState)
                setResponse({
                  error: null,
                  success: 'Mudda has been updated',
                })
                setLoading(false)
              } else {
                console.log(res.data)
                setResponse({
                  error: 'Failed to update',
                  success: null,
                })
                setLoading(false)
              }
            })
            .catch((e) => console.log(e.message))
        : MuddaAPI.createMudda(user.access_token, muddaData)
            .then((res) => {
              if (res.data.status === true) {
                setLoading(false)
                setMuddaData(initialState)
                setResponse({
                  error: null,
                  success: 'New Mudda has been created',
                })
                setReload(!reload)
              }
            })
            .catch((e) => console.log(e.message))

      setTimeout(
        () =>
          setResponse({
            success: null,
            error: null,
          }),
        CONSTANTS.ALERT_TIME_OUT,
      )
    }
  }

  return (
    <CCard className="mb-4">
      <CCardHeader>{editMode ? 'Edit Mudda' : 'नयाँ मुद्दा'}</CCardHeader>
      <CCardBody>
        {response.success ? <Alert severity="success">{response.success}</Alert> : null}
        {response.error ? <Alert severity="error">{response.error}</Alert> : null}

        {fetching ? (
          <CircularProgress />
        ) : (
          <CForm className={response.success || response.error ? 'mt-4' : null}>
            <CRow>
              <CCol md="12">
                <div className="mb-3">
                  <CFormLabel htmlFor="muddaName">मुद्दा को नाम</CFormLabel>

                  <CFormInput
                    type="text"
                    id="muddaName"
                    placeholder=""
                    name="name"
                    value={muddaData.name}
                    onChange={handleMuddaDataChange}
                  />
                </div>
              </CCol>

              <CCol md="12">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <CButton type="submit" color="primary" size="sm" onClick={handleSubmit}>
                    {editMode ? 'Save' : 'मुद्दा बनाउनुहोस'}
                  </CButton>
                )}
                &nbsp;{' '}
                {editMode ? (
                  <CButton color="danger" size="sm" variant="outline" onClick={handleClose}>
                    Close
                  </CButton>
                ) : null}
              </CCol>
            </CRow>
          </CForm>
        )}
      </CCardBody>
    </CCard>
  )
}

export default MuddaForm

MuddaForm.propTypes = {
  editMode: PropTypes.bool,
  handleClose: PropTypes.func,
}

MuddaForm.defaultProps = {
  editMode: false,
  handleClose: () => console.log('Clicked'),
}
